import fetchClient from "api/client";
import { stringify } from "qs";
import INSIGHTS_ENDPOINT from "./insightsEndpoint";

/**
 * @description GET api/insights/parse-query
 * */
export default function getAiParsing(search) {
  const queryString = stringify(
    {
      search,
    },
    { addQueryPrefix: true },
  );

  return fetchClient.get(`${INSIGHTS_ENDPOINT}/parse-query${queryString}`);
}
